export namespace Barrier {
  export enum Action {
    GateInfo = 'GateInfo',
    GateMake = 'gate_MK',
    OpenGateMoto = 'openGateMoto',
  }

  export enum Commands {
    GetList = 'LIST',
    OpenBarrier = 'OPEN',
    GetActionsListing = 'RptCamerasOpen',
    SetDemoMoves = 'setDemoMovs',
    ClearGateSum = 'ClearGateSum',
    EnterBlock = 'EnterBlock',
    SumInfo = 'sumInfo',
    HoldOpenGate = 'HoldOpenGate',
  }

  export interface Entity {
    camId: number;
    movId: number;
    carId: number;
    carNumber: string;
    color1: string;
    color2: string;
    gateName: string;
    mode: CarNumberMode;
    scOpenCarCard: boolean;
    scOpenMotocycleFlag?: boolean;
    scOpenGate: boolean;
    scDemoMovs?: number;
    scOpenCardMakeCopy?: boolean;
    scCarOtherCorp?: boolean;
    stayTime: string;
    str1: string;
    str2: string;
    tSum?: number;
    urlVideo?: string;
    carDolg?: string;
    parkId?: number;
    globalParkId?: number;
    parkName?: string;
    phone?: string;
    email?: string;
    theftFlag: boolean;
    gateType: GateType;
    similarNumberFlag?: boolean;

    corpId?: number;
    corpName?: string;
    trailerRequestFlag?: boolean;

    trailerId?: number;
    trailerCarNumber?: string;
    trailerPriority?: boolean;
    scTrailer?: boolean;
    dftVisitPurposeId?: number;

    scEnterBlockedFlag?: boolean;
    enterBlockedFlag?: boolean;

    scPayCashFlag?: boolean;
    scHoldOpenGateFlag?: boolean; // Держать ШБ открытым
  }

  export enum GateType {
    Enter = 'enter',
    Exit = 'exit',
  }

  export enum LocalStorageKeys {
    SelectedPark = 'selectedPark',
    ArchiveCarNumbers = 'archiveCarNumbers',
    SortedCams = 'barrierSortedCams',
    DemoMovesNumber = 'demoMovesCarNumber',
    DemoMovesNumberArray = 'demoMovesCarNumberArray',
    ListOrder = 'barriers-list-order',
  }

  export enum CarNumberMode {
    Pay = 'pay',
    Enter = 'enter',
    PrivateEnter = 'privat enter',
    DolgButton = 'dolg button',
    GoodWay = 'good way',
    NotFound = 'not find',
    NoCar = 'no car',
    Blocked = 'blocked',
    Trailer = 'trailer',
    NoPing = 'no ping',
    HoldOpenGate = 'holdOpenGate',
  }

  export enum BusEvents {
    StopLoadingBarriers = 'barriers:stop-loading',
    RestartLoadBarriers = 'barriers:restart-loading',
    ChangeListOrdering = 'barriers:change-listing-ordering',
    ClearListOrdering = 'barriers:clear-listing-ordering',
  }

  export interface IDemoCarsBook {
    name: string;
    carNumber: string;
  }
}
